export const FAQ_CUSTOMER_START = "FAQ_CUSTOMER_START";
export const FAQ_CUSTOMER_SUCCESS = "FAQ_CUSTOMER_SUCCESS";
export const FAQ_CUSTOMER_ERROR = "FAQ_CUSTOMER_ERROR";